import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-semi-bold" }
const _hoisted_2 = {
  key: 0,
  class: "text-semi-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["LotAssignmentModal"], {
    "is-open": !!$props.showModal,
    onClose: $setup.close,
    onConfirm: $setup.confirm
  }, _createSlots({
    title: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-semi-bold" }, "Confirm action", -1))
    ]),
    _: 2
  }, [
    ($props.showModal === 'cancelOption')
      ? {
          name: "description",
          fn: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Are you sure you want to cancel option?", -1))
          ]),
          key: "0"
        }
      : ($props.showModal === 'unrelease' || $props.showModal === 'cancelOffline')
        ? {
            name: "description",
            fn: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Are you sure you want to unrelease ", -1)),
              _createElementVNode("span", _hoisted_1, "Lot " + _toDisplayString($props.lot.title), 1),
              _createElementVNode("span", null, "? This lot will be marked as 'Not Released'. " + _toDisplayString($props.showModal === "unrelease" ? "New potential buyers will not be able to submit Contract information forms for this lot." : ""), 1)
            ]),
            key: "1"
          }
        : ($props.showModal === 'returnPreviousStatus')
          ? {
              name: "description",
              fn: _withCtx(() => [
                _createElementVNode("span", null, "Are you sure you want back to " + _toDisplayString($setup.getLotPreviousStatus($props.lot?.status)=== $setup.LotStatus.EOI
? $setup.LotStatus.PRE_CONTRACT
: $setup.getLotPreviousStatus($props.lot.status)) + " step?", 1)
              ]),
              key: "2"
            }
          : ($props.showModal === 'markSettled')
            ? {
                name: "description",
                fn: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Are you sure you want to mark this lot as Settled? This is a final step, you will not be able to go back.", -1))
                ]),
                key: "3"
              }
            : {
                name: "description",
                fn: _withCtx(() => [
                  _createElementVNode("span", null, "Are you sure you want to " + _toDisplayString($props.showModal === "revokeEoi" ? "revoke reservation from " : "terminate this contract"), 1),
                  ($props.showModal === 'revokeEoi')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.getFirstLastName($props.lot?.buyerId)), 1))
                    : _createCommentVNode("", true),
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "?", -1))
                ]),
                key: "4"
              }
  ]), 1032, ["is-open"]))
}